import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  readArticleClusteringFromStorage,
  writeArticleClusteringToStorage,
} from '@/core/constants/preferences';

import { api } from '@/features/UserPreferences/api';
import { clearReportsLists } from '@/features/Reports/store/slices';

import { getActionPrefix } from '@/utils/helpers';

import {
  incrementReportsPreferenceVersion,
  setArticleClusteringEnabled,
  setArticleClusteringPreferenceLoaded,
} from './slice';

const actionPrefix = getActionPrefix('userPreferences');

/** Hydrate Redux from localStorage (used when the API is unavailable in local dev). */
export const hydrateArticleClusteringPreference = createAsyncThunk(
  `${actionPrefix}/hydrateArticleClusteringPreference`,
  async (_, { dispatch }) => {
    const stored = readArticleClusteringFromStorage();

    if (stored !== null) {
      dispatch(setArticleClusteringEnabled(stored));
    }

    dispatch(setArticleClusteringPreferenceLoaded(true));
  }
);

export const updateArticleClusteringPreference = createAsyncThunk(
  `${actionPrefix}/updateArticleClusteringPreference`,
  async (articleClusteringEnabled: boolean, { dispatch, rejectWithValue }) => {
    writeArticleClusteringToStorage(articleClusteringEnabled);
    dispatch(setArticleClusteringEnabled(articleClusteringEnabled));
    dispatch(clearReportsLists());
    dispatch(incrementReportsPreferenceVersion());

    try {
      const { data } = await api.updateArticleClustering({
        articleClusteringEnabled,
      });

      dispatch(setArticleClusteringEnabled(data.articleClusteringEnabled));
      writeArticleClusteringToStorage(data.articleClusteringEnabled);

      return data.articleClusteringEnabled;
    } catch (error) {
      return rejectWithValue(null);
    }
  }
);
